import { render, staticRenderFns } from "./PassengersConfirmation.vue?vue&type=template&id=193d117b&scoped=true&"
import script from "./PassengersConfirmation.vue?vue&type=script&lang=js&"
export * from "./PassengersConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d117b",
  null
  
)

export default component.exports